import "./cards.scss";
import swiper from "../js/slider";

const swiperSelectorString = "section.cards .swiper";
const options = {
  spaceBetween: 20,
  autoHeight: false,
  slidesPerView: 3,
  autoplay: true,
  rewind: true,
  centeredSlides: true,
  centeredSlidesBounds: true,
  grabCursor: true,
  loop: true,
  // loopAddBlankSlides: true,
  setWrapperSize: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 5,
      centeredSlides: true,
    },
    // when window width is >= 320px
    // 320: {
    //   slidesPerView: 2,
    //   spaceBetween: 20
    // },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};
swiper(swiperSelectorString, options);
